import { HStack } from '@sgme/ui';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { FormattedMessage } from 'react-intl';

import { useUpdateUserPreferencesMutation } from '@/api/user/index.ts';
import { useAppSelector } from '@/store/hooks.ts';
import { getUserPreferences } from '@/store/userPreferences/slice.ts';

const OptionExpandGreekAndMkt = () => {
  const [updateUserPreferences] = useUpdateUserPreferencesMutation();
  const userPreferences = useAppSelector(getUserPreferences);
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const handleChange = (): void => {
    sgwtWebAnalytics?.trackEvent(
      'Header',
      'user preferences, option tab, option expand greek and mkt',
      String(!userPreferences.optionExpandGreekAndMkt),
    );
    updateUserPreferences({ ...userPreferences, optionExpandGreekAndMkt: !userPreferences.optionExpandGreekAndMkt });
  };

  return (
    <div className="d-flex align-items-center justify-content-between p-3 px-4 border-bottom">
      <label htmlFor="option-expand-greek-and-mkt">
        <FormattedMessage id="userPreferences.label.optionExpandGreekAndMkt" />
      </label>
      <HStack className="form-check-sm form-check-valid form-switch" data-e2e="optionExpandGreekAndMkt">
        <input
          id="option-expand-greek-and-mkt"
          className="form-check-input me-8px"
          type="checkbox"
          checked={userPreferences.optionExpandGreekAndMkt}
          onChange={handleChange}
          data-e2e={'optionExpandGreekAndMkt-checkbox'}
        />
        <span>
          <FormattedMessage id={`switchInput.${userPreferences.optionExpandGreekAndMkt ? 'on' : 'off'}`} />
        </span>
      </HStack>
    </div>
  );
};

export default OptionExpandGreekAndMkt;
